/* CUBE STORE - i due tasti sotto la tabella taglie e la loro finestra

   In Magical Form Fields ci sono due moduli, e ognuno va nel suo tasto:

     "Pagamento Su Misura"      -> tasto PROCEDI ALL'ACQUISTO
     "Prenotazione con Acconto" -> tasto PRENOTA

   ==========================================================
   IL PERCORSO SU MISURA E' SPENTO (di nuovo)
   ==========================================================

   Il tasto PROCEDI ALL'ACQUISTO - e con lui la finestra del modulo
   "Pagamento Su Misura" - e' stato spento il 10 agosto 2026, riacceso
   l'11, e rispento lo stesso giorno su decisione di Marco e Alberto.
   Stato attuale: sulla PRONTA CONSEGNA il cliente vede solo il
   pulsante del tema, AGGIUNGI AL CARRELLO, e paga in cassa come in
   qualunque negozio. La PRENOTAZIONE non c'entra: PRENOTA, la sua
   finestra e il modulo dell'acconto restano accesi.

   L'INTERRUTTORE E' UNA RIGA SOLA: la voce su-misura dentro AZIONI,
   qui sotto. Commentarla spegne l'intero percorso, e non serve toccare
   nient'altro. Vale la pena sapere perche', cosi' la prossima volta
   nessuno va a cercare altri interruttori in giro:

     - senza quella voce nessun tasto su-misura viene creato, quindi
       aggiornaTasti() non ha niente da accendere;
     - con la fila di tasti vuota, cube-azioni-colonna.js non mette
       piu' la classe cube-acquisto-via, e il pulsante del tema torna
       visibile da se';
     - cube-gruppi.js all'avvio tiene spenti tutti e due i moduli e ne
       riaccende uno solo all'apertura di una finestra: non aprendosi
       mai quella del su-misura, i suoi campi restano disattivati - e
       un campo disattivato non viene ne' convalidato ne' inviato.

   Spegnendolo il modulo resta in pagina, invisibile e muto: nell'ordine
   non arriva nessuna sua risposta. In Magical Form Fields il gruppo non
   va toccato - e infatti nel giorno di spegnimento e' rimasto attivo
   con i suoi dieci campi, ed e' per questo che riaccenderlo e' bastato
   togliere un commento.

   ==========================================================

   Attenzione ai nomi: il modulo nell'app si chiama ancora "Pagamento
   Su Misura" e l'identificativo interno e' su-misura, ma il tasto che
   vede il cliente dice PROCEDI ALL'ACQUISTO. Rinominare il modulo
   nell'app non cambierebbe il tasto, e viceversa: l'unico punto in cui
   si cambia la scritta e' AZIONI, qui sotto.

   QUANDO COMPARE UN TASTO: DUE DOMANDE, NON UNA

   1) il modulo esiste su questo prodotto?
      Lo decide l'app - categorie, collezioni - e qui non si
      riscrive: sarebbe una seconda lista da tenere allineata a mano, e
      prima o poi le due divergono. Si guarda il risultato: gruppo non
      in pagina, tasto via. Su un accessorio non compare niente.

   2) serve su QUESTA taglia?
      Questa l'app non sa rispondere, ed e' bene sapere perche' prima
      di andarla a cercare. Fra le sue condizioni ci sono Product Type,
      Option Name e Option Value: parlano di COS'E' il prodotto, mai di
      SE CE L'HAI. Nessun criterio su giacenza o disponibilita'. E
      soprattutto valuta le condizioni una volta per prodotto, non a
      ogni cambio taglia: su una bici con la S in pronta consegna e la L
      da ordinare darebbe una risposta sola per tutte e cinque. Quindi
      la seconda domanda si risponde qui.

   TRE STATI, E OGNUNO HA IL SUO TASTO

     taglia PRENOTABILE        -> solo PRENOTA
     taglia in PRONTA CONSEGNA -> solo PROCEDI ALL'ACQUISTO
     taglia ESAURITA           -> nessuno dei due

   (Oggi, con il su-misura spento, la riga di mezzo non produce nessun
   tasto: sulla pronta consegna comanda il pulsante del tema.)

   I primi due si escludono perche' rispondono a situazioni diverse: una
   bici gia' in negozio non si prenota, si compra; una che arriva a
   settembre non si paga oggi in un'unica soluzione, si versa un acconto
   - e il modulo dell'acconto chiede gia' lui come si salda. Mostrarli
   insieme voleva dire far scegliere al cliente fra due strade di cui
   una porta a un errore, e non e' una scelta: e' una trappola.

   Sull'esaurita non c'e' niente da ordinare, quindi non c'e' niente da
   chiedere: qualunque modulo di pagamento li' e' una domanda su un
   acquisto che non puo' avvenire. Il pulsante del tema dice ESAURITO ed
   e' disabilitato da lui, senza bisogno che ci mettiamo mano.

   La risposta arriva da window.cubeStatoTaglia (cube-etichetta.js), che
   legge la riga selezionata della tabella - la stessa da cui nasce la
   scritta PRENOTA sul pulsante di acquisto. Se rispondesse null, cioe'
   "non lo so", tornano a mostrarsi entrambi: meglio un tasto di troppo
   che un cliente senza strada per ordinare.

   DURANTE LA PRENOTAZIONE IL BLOCCO ACQUISTO SPARISCE DALLA COLONNA
   Su una taglia prenotabile c'erano due pulsanti neri identici a pochi
   pixel di distanza: il nostro PRENOTA e quello del tema, che
   cube-etichetta.js aveva gia' ribattezzato PRENOTA. Uguali a vedersi
   ma non a premersi - il secondo aggiunge al carrello senza passare
   dal modulo, cioe' senza chiedere l'acconto.

   Si nasconde SOLO finche' sta al suo posto. Appena entra nel piede
   della finestra torna visibile, perche' li' e' il pulsante con cui si
   conclude davvero l'ordine - ed e' lo stesso identico nodo, non una
   copia. Percio' la decisione guarda dove si trova, non solo la
   taglia.

   L'ICONA DEL CARRELLO E' CLONATA, NON RIDISEGNATA
   Si prende dal pulsante di acquisto vero e se ne appende una copia a
   ogni tasto. Incollare qui il codice dell'icona voleva dire tenerne
   una seconda versione allineata a mano al tema: al primo
   aggiornamento di Horizon le due si sarebbero sfasate, e in modo
   visibile - due carrelli diversi nella stessa colonna.

   La copia perde le classi del tema e ne riceve una nostra, perche' le
   misure dell'icona nel tema valgono solo dentro il pulsante di
   acquisto: fuori di li' quegli SVG, che non hanno width ne' height
   scritte, si allargano a tutto lo spazio disponibile. La misura gliela
   da' cube-azioni.css.

   Se il pulsante di acquisto non fosse ancora in pagina, i tasti
   nascono senza icona e la ricevono al giro successivo: metteIcone()
   viene richiamata a ogni modifica del DOM e riempie solo i vuoti.

   I tasti nascono nascosti e si accendono quando i moduli arrivano:
   l'app li disegna dopo il caricamento della pagina, e un tasto che
   lampeggia per mezzo secondo prima di sparire e' peggio di uno che
   arriva un istante dopo.

   DENTRO LA FINESTRA C'E' IL PULSANTE VERO, NON UNA COPIA
   Due tentativi falliti prima di arrivarci, e vale la pena ricordarli
   perche' fallivano in modi diversi e silenziosi:

   1) un pulsante nostro che chiamava vero.click(). Non succedeva
      niente: il pulsante di acquisto sta dentro <add-to-cart-component>,
      che intercetta l'INVIO del form e non il click.

   2) lo stesso pulsante con form.requestSubmit(). L'articolo entrava,
      ma senza le risposte dei moduli: Magical aggancia il CLICK per
      infilare le sue risposte nel form, e con requestSubmit quel click
      non esiste. Ordine giusto, dichiarazione di pagamento persa.

   Le due app ascoltano due cose diverse, quindi qualunque imitazione ne
   scontenta una. Si sposta il blocco quantita' + acquisto dentro il
   piede della finestra e si rimette al suo posto alla chiusura.

   IL TRASLOCO HA UN PREZZO, E VA PAGATO OGNI VOLTA
   Spostare un elemento personalizzato nel DOM lo scollega e lo
   ricollega, e i componenti del tema al collegamento rileggono lo
   stato in cui si trovano. <quantity-selector-component> in
   particolare, quando si collega, si segna come "deciso dal server"
   qualunque pulsante trovi gia' disabilitato, e da quel momento non lo
   riaccende piu'. A quantita' 1 il meno e' spento - lo ha spento lui -
   quindi dopo il trasloco se lo ritrova spento, se lo segna, e resta
   spento per sempre: si poteva salire di quantita' ma non tornare
   indietro. Vedi portaAcquisto() piu' sotto.

   LA FINESTRA STA DENTRO IL FORM DEL PRODOTTO
   Il pulsante spostato deve restare nel suo form. E il form si trova
   DAL PULSANTE, non con form[action*="/cart/add"]: quel selettore
   pesca anche il form nascosto "payment-terms" di Shopify, largo zero
   pixel, dentro cui la finestra restava invisibile.

   NON SI SPOSTANO I SINGOLI GRUPPI
   E' l'app a gestire il contenuto di <custom-fields>: portandole via un
   figlio, al giro dopo ne disegnava uno solo. Si sposta il blocco
   INTERO e dentro la finestra si mostra solo il gruppo che serve.

   COME SI RICONOSCONO I DUE MODULI
   L'app non mette in pagina il nome del gruppo: resta il contenuto. Si
   guarda la parola "acconto", che compare solo nel modulo della
   prenotazione. Se un domani quel modulo viene rinominato togliendo
   quella parola, i due contenuti si scambiano: e' qui che si mette
   mano. */
(function () {
  /* serve() = la seconda domanda, quella sulla taglia scelta.
     null significa "non lo so" - non "non si puo'" - quindi si
     risponde di si' a tutti e due: meglio un tasto di troppo che un
     cliente senza strada per ordinare. */
  function stato() {
    if (typeof window.cubeStatoTaglia !== 'function') return null;
    return window.cubeStatoTaglia();
  }

  function tagliaPrenotabile() {
    var s = stato();
    return s === null || s === 'prenotabile';
  }

  function tagliaDaComprare() {
    var s = stato();
    return s === null || s === 'pronta';
  }

  /* etichetta = la scritta sul tasto E il titolo della finestra: sono
     la stessa azione vista da due momenti diversi, e tenerle allineate
     a mano vorrebbe dire prima o poi cliccare una cosa e trovarne
     un'altra scritta in alto. id resta su-misura: lo usano il CSS, la
     classificazione dei gruppi e il ricordo di quale tasto ha aperto. */

  var AZIONI = [
    { id: 'prenota', etichetta: 'Prenota', serve: tagliaPrenotabile }

    /* SPENTO, NON CANCELLATO - vedi "IL PERCORSO SU MISURA E' SPENTO"
       in testa al file. Per riaccenderlo basta togliere il commento
       alla riga qui sotto, e nient'altro:

    , { id: 'su-misura', etichetta: "Procedi all'acquisto", serve: tagliaDaComprare }
    */
  ];

  var SEGNO_PRENOTA = /acconto/i;

  var modale = null;
  var corpo = null;
  var piede = null;
  var titolo = null;
  var ultimoFocus = null;

  /* segnaposto: ricorda dove stava il blocco acquisto, per rimettercelo */
  var segnaposto = null;

  function bloccoAcquisto() {
    return document.querySelector('.product-form-buttons');
  }

  function formDelProdotto() {
    var b = document.querySelector('.add-to-cart-button');
    return b ? b.closest('form') : null;
  }

  /* ---------- il selettore quantita' sopravvive al trasloco ---------- */

  /* Vedi "IL TRASLOCO HA UN PREZZO" in testa. I due contrassegni sono
     campi pubblici del componente del tema, quindi si possono leggere e
     riscrivere: si salvano prima di spostare e si rimettono dopo, poi
     si chiede al componente di ricalcolare da se'.

     Cosi' un pulsante spento davvero dal server - perche' il prodotto
     non ammette quella quantita' - resta spento, e uno spento dal
     componente stesso torna a ragionare sul valore corrente. Rimetterli
     a false e basta sarebbe stato piu' corto e sbagliato: avrebbe
     riacceso anche i divieti veri. */

  function selettoreQuantita(blocco) {
    return blocco ? blocco.querySelector('quantity-selector-component') : null;
  }

  function memoriaQuantita(sel) {
    if (!sel) return null;
    return { meno: sel.serverDisabledMinus, piu: sel.serverDisabledPlus };
  }

  function rimettiQuantita(sel, memoria) {
    if (!sel || !memoria) return;
    sel.serverDisabledMinus = memoria.meno;
    sel.serverDisabledPlus = memoria.piu;
    if (typeof sel.updateButtonStates === 'function') sel.updateButtonStates();
  }

  /* ---------- l'icona del carrello ---------- */

  function icona() {
    var vera = document.querySelector('.add-to-cart-button .add-to-cart-icon');
    if (!vera) return null;

    var copia = vera.cloneNode(true);
    /* via le classi del tema: le loro misure valgono solo dentro il
       pulsante di acquisto - vedi il commento in testa */
    copia.className = 'cube-azioni__icona';
    copia.setAttribute('aria-hidden', 'true');
    return copia;
  }

  function metteIcone() {
    var fila = document.querySelector('.cube-azioni');
    if (!fila) return;

    fila.querySelectorAll('.cube-azioni__tasto').forEach(function (tasto) {
      if (tasto.querySelector('.cube-azioni__icona')) return;
      var ico = icona();
      if (ico) tasto.insertBefore(ico, tasto.firstChild);
    });
  }

  /* ---------- etichettare i due moduli ---------- */

  function classifica() {
    document.querySelectorAll('.ma-custom-field-group').forEach(function (g) {
      var tipo = SEGNO_PRENOTA.test(g.textContent || '') ? 'prenota' : 'su-misura';
      var classe = 'cube-gruppo--' + tipo;
      if (g.classList.contains(classe)) return;
      g.classList.remove('cube-gruppo--prenota', 'cube-gruppo--su-misura');
      g.classList.add('cube-gruppo', classe);
    });
  }

  /* ---------- quali tasti mostrare ---------- */

  function aggiornaTasti() {
    var fila = document.querySelector('.cube-azioni');
    if (!fila) return;

    var vivi = 0;

    AZIONI.forEach(function (azione) {
      var tasto = fila.querySelector('[data-azione="' + azione.id + '"]');
      if (!tasto) return;

      var ceIlModulo = !!document.querySelector('.cube-gruppo--' + azione.id);
      var serve = ceIlModulo && azione.serve();

      tasto.hidden = !serve;
      if (serve) vivi++;
    });

    /* niente moduli, niente riga: sugli accessori - e sulle taglie
       esaurite - non deve restare una fascia vuota sotto la tabella */
    fila.hidden = vivi === 0;

    /* con un tasto solo prende tutta la larghezza, altrimenti resta
       una mezza riga con un buco accanto. Da quando i due sono
       alternativi questo e' il caso normale, non l'eccezione. */
    fila.classList.toggle('cube-azioni--solo', vivi === 1);

    nascondiAcquistoDuranteLaPrenotazione(fila);

    /* la taglia e' cambiata a finestra aperta e quell'azione non ha
       piu' senso: si chiude. Non e' pignoleria - dentro la finestra c'e'
       il blocco acquisto vero, e lasciarcelo dentro a tasto sparito
       vuol dire togliere al cliente il pulsante per comprare. Vale
       anche passando a una taglia esaurita, dove non resta nessun
       tasto acceso. */
    if (modale && !modale.hidden) {
      var aperto = fila.querySelector('[data-azione="' + modale.dataset.azione + '"]');
      if (aperto && aperto.hidden) chiudiModale();
    }
  }

  /* Due pulsanti neri identici a pochi pixel di distanza, e solo uno
     dei due chiede l'acconto: vedi il commento in testa. Si guarda
     anche DOVE si trova il blocco, perche' nella finestra e' lo stesso
     nodo e li' deve vedersi. */
  function nascondiAcquistoDuranteLaPrenotazione(fila) {
    var blocco = bloccoAcquisto();
    if (!blocco) return;

    var dentroLaFinestra = !!(piede && blocco.parentElement === piede);
    var prenota = fila.querySelector('[data-azione="prenota"]');
    var siPrenota = !!prenota && !prenota.hidden;

    blocco.hidden = siPrenota && !dentroLaFinestra;
  }

  /* ---------- la finestra ---------- */

  function costruisciModale() {
    if (modale) return;

    modale = document.createElement('div');
    modale.className = 'cube-modale';
    modale.id = 'cube-modale';
    modale.hidden = true;
    modale.setAttribute('role', 'dialog');
    modale.setAttribute('aria-modal', 'true');
    modale.setAttribute('aria-labelledby', 'cube-modale-titolo');

    var riquadro = document.createElement('div');
    riquadro.className = 'cube-modale__riquadro';

    var testa = document.createElement('div');
    testa.className = 'cube-modale__testa';

    titolo = document.createElement('h2');
    titolo.className = 'cube-modale__titolo';
    titolo.id = 'cube-modale-titolo';

    var chiudi = document.createElement('button');
    chiudi.type = 'button';
    chiudi.className = 'cube-modale__chiudi';
    chiudi.setAttribute('aria-label', 'Chiudi');
    chiudi.innerHTML = '&times;';
    chiudi.addEventListener('click', chiudiModale);

    testa.appendChild(titolo);
    testa.appendChild(chiudi);

    corpo = document.createElement('div');
    corpo.className = 'cube-modale__corpo';

    piede = document.createElement('div');
    piede.className = 'cube-modale__piede';

    riquadro.appendChild(testa);
    riquadro.appendChild(corpo);
    riquadro.appendChild(piede);
    modale.appendChild(riquadro);

    modale.addEventListener('click', function (e) {
      if (e.target === modale) chiudiModale();
    });

    (formDelProdotto() || document.body).appendChild(modale);
  }

  function portaAcquisto() {
    var blocco = bloccoAcquisto();
    if (!blocco || !piede) return;
    if (blocco.parentElement === piede) return;

    /* prima di scollegarlo: vedi "IL TRASLOCO HA UN PREZZO" */
    var sel = selettoreQuantita(blocco);
    var memoria = memoriaQuantita(sel);

    segnaposto = document.createComment('cube-acquisto');
    blocco.parentElement.insertBefore(segnaposto, blocco);
    piede.appendChild(blocco);

    rimettiQuantita(sel, memoria);

    /* subito, senza aspettare il giro dell'osservatore: altrimenti il
       piede della finestra si aprirebbe vuoto per un fotogramma */
    blocco.hidden = false;
  }

  function rendiAcquisto() {
    var blocco = bloccoAcquisto();
    if (!blocco || !segnaposto || !segnaposto.parentElement) return;

    var sel = selettoreQuantita(blocco);
    var memoria = memoriaQuantita(sel);

    segnaposto.parentElement.insertBefore(blocco, segnaposto);
    segnaposto.remove();
    segnaposto = null;

    rimettiQuantita(sel, memoria);
  }

  function etichettaDi(id) {
    for (var i = 0; i < AZIONI.length; i++) {
      if (AZIONI[i].id === id) return AZIONI[i].etichetta;
    }
    return '';
  }

  function apriModale(id) {
    /* Un'azione che non esiste in AZIONI non apre niente. Serve quando
       una voce viene spenta - vedi "IL PERCORSO SU MISURA E' SPENTO" in testa - perche'
       l'ascoltatore di invalid qui sotto potrebbe chiamarci con
       l'identificativo del modulo spento, e aprirebbe una finestra
       senza titolo su qualcosa che non deve comparire. */
    if (!etichettaDi(id)) return;

    costruisciModale();
    classifica();

    ultimoFocus = document.activeElement;
    titolo.textContent = etichettaDi(id);

    var blocco = document.querySelector('custom-fields');
    if (blocco && blocco.parentElement !== corpo) corpo.appendChild(blocco);

    /* solo i campi di questo modulo restano attivi */
    if (window.cubeAbilitaSolo) window.cubeAbilitaSolo(id);

    portaAcquisto();

    modale.dataset.azione = id;
    modale.hidden = false;
    document.body.classList.add('cube-modale-aperta');

    var x = modale.querySelector('.cube-modale__chiudi');
    if (x) x.focus();
  }

  function chiudiModale() {
    if (!modale || modale.hidden) return;

    rendiAcquisto();

    modale.hidden = true;
    document.body.classList.remove('cube-modale-aperta');

    if (ultimoFocus && ultimoFocus.focus) ultimoFocus.focus();
    ultimoFocus = null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') chiudiModale();
  });

  document.addEventListener('invalid', function (e) {
    var campo = e.target;
    var g = campo.closest ? campo.closest('.ma-custom-field-group') : null;
    if (!g) return;

    var tipo = SEGNO_PRENOTA.test(g.textContent || '') ? 'prenota' : 'su-misura';
    if (!modale || modale.hidden || modale.dataset.azione !== tipo) {
      apriModale(tipo);
    }

    requestAnimationFrame(function () {
      if (campo.focus) campo.focus();
    });
  }, true);

  /* ---------- i due tasti ---------- */

  function tasti() {
    var card = document.querySelector('.vb-availability-card');
    if (!card || card.dataset.cubeAzioni === '1') return;

    card.dataset.cubeAzioni = '1';

    var fila = document.createElement('div');
    fila.className = 'cube-azioni';
    /* nascosta finche' non si sa se serve: vedi il commento in testa */
    fila.hidden = true;

    AZIONI.forEach(function (azione) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cube-azioni__tasto';
      b.dataset.azione = azione.id;
      b.hidden = true;

      var ico = icona();
      if (ico) b.appendChild(ico);

      /* la scritta in un suo elemento: accanto all'icona serve un
         appiglio per l'allineamento, e un nodo di testo nudo non ce
         l'ha */
      var testo = document.createElement('span');
      testo.className = 'cube-azioni__testo';
      testo.textContent = azione.etichetta;
      b.appendChild(testo);

      b.addEventListener('click', function (e) {
        e.preventDefault();
        apriModale(azione.id);
      });

      fila.appendChild(b);
    });

    card.insertAdjacentElement('afterend', fila);
  }

  /* ---------- avvio ---------- */

  var inCoda = false;
  function programma() {
    if (inCoda) return;
    inCoda = true;
    requestAnimationFrame(function () {
      inCoda = false;
      tasti();
      metteIcone();
      classifica();
      aggiornaTasti();
    });
  }

  function init() {
    tasti();
    metteIcone();
    classifica();
    aggiornaTasti();
    if (!document.body) return;
    new MutationObserver(programma).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
